<template>
    <div class="confirm-subscribe-page">
        <Logo class="confirm-subscribe-page__logo"/>
        <div class="confirm-subscribe-page__card">
            <template v-if="loading">
                <confirm-subscribe-skeleton/>
                <app-loading/>
            </template>
            <template v-else>
                <template v-if="error">
                    <div class="confirm-subscribe-page__card-title">
                        邮箱验证链接不存在或已订阅。
                    </div>
                    <div class="confirm-subscribe-page__card-body">
                        <p class="confirm-subscribe-page__p">
                            请重新发起订阅请求
                        </p>
                    </div>
                    <div class="confirm-subscribe-page__card-footer">
                        <app-button class="confirm-subscribe-page__button" to="subscribe">订阅</app-button>
                    </div>
                </template>
                <template v-else>
                    <div class="confirm-subscribe-page__card-title">
                        订阅成功
                    </div>
                    <div class="confirm-subscribe-page__card-body">
                        <p class="confirm-subscribe-page__p">
                            很高兴订阅我的博客，您会收到我关于新博客发布相关的电子邮件。
                        </p>
                        <p class="confirm-subscribe-page__p">
                            我发送的有关新博客发布的每封电子邮件的底部都将提供退订链接。如果您不想收到与此有关的电子邮件，请随时使用它！
                        </p>
                        <p class="confirm-subscribe-page__p">
                            谢谢!
                        </p>
                    </div>
                    <div class="confirm-subscribe-page__card-footer">
                        <app-button class="confirm-subscribe-page__button" to="home">开始浏览</app-button>
                    </div>
                </template>
            </template>


        </div>
    </div>
</template>

<script>
    import Logo from '@assets/svg/inline.logo.svg'
    import ConfirmSubscribeSkeleton from '@assets/svg/inline.confirm-subscribe-skeleton.svg'
    import AppButton from '@components/AppButton'
    import AppLoading from '@components/AppLoading'

    import confirmSubscribeService from '@service/confirmSubscribeService'

    export default {
        name: "Subscribe",
        data() {
            return {
                loading: false,
                error: false
            }
        },
        computed: {
            id() {
                return this.$route.query.subscribe
            }
        },
        watch: {
            id: {
                handler(val) {
                    if (!val) {
                        this.error = true
                        return
                    }
                    this.confirmSubscribe(val)
                },
                immediate: true
            }
        },
        methods: {
            async confirmSubscribe(id) {
                try {
                    this.loading = true
                    await confirmSubscribeService({id})
                } catch (e) {
                    this.error = e.message
                } finally {
                    this.loading = false
                }
            }
        },
        components: {
            AppButton,
            Logo,
            ConfirmSubscribeSkeleton,
            AppLoading
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .confirm-subscribe-page {
        width: 100%;
        min-height: 100%;

    }

    .confirm-subscribe-page {
        padding: $paddingSP;
        padding-top: 70px;
        color: $textColor;
        color: var(--textColor);
        @include transition-colors;

        &__logo {
            width: 150px;
            margin: 0 auto $paddingSP;
        }

        &__card {
            max-width: 600px;
            margin: 0 auto;
            padding: $paddingMD;
            // background-color: $darkComponentBackgroundColor;
            // border-radius: $radius;

            &-title {
                font-size: $fontSizeLG;
                font-weight: $fontWeightBolder;
                margin-bottom: $paddingLG;
            }
        }

        &__p {
            font-size: $fontSize;
            line-height: 2;
            margin-bottom: $paddingMD;
        }

        &__card-footer {
            margin-top: $paddingLG;
            text-align: center;
        }

        &__button {
            display: inline-block;
            padding: $paddingBase $paddingMD;
            border-radius: $radius;
            color: #fff;
            background-color: $darkPrimaryColor;

            &:hover {
                color: #fff;
                background-color: $primaryColor;
            }
        }
    }
</style>